import { setDiscordPromoDismissed } from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { getRequestLogger, logRequestError } from "#/lib/requestLogger.server";
import { emptyServerInputSchema } from "#/lib/serverInputSchemas";
import { authedMiddleware } from "#/server/authedMiddleware";

export const dismissDiscordPromo = createServerFn({ method: "POST" })
  .middleware([authedMiddleware])
  .validator(emptyServerInputSchema)
  .handler(async ({ context }) => {
    getRequestLogger().set({ profile: { action: "dismiss_discord_promo" } });
    try {
      await setDiscordPromoDismissed(context.userId);
    } catch (error) {
      logRequestError({
        log: getRequestLogger(),
        error,
        context: { profile: { step: "dismiss_discord_promo" } },
      });
      throw error;
    }
  });
